export const TEMPLATE_IMPORT_METHODS = {
  THIRD_PARTY: 'third_party',
  SPM_FILE: 'spm_file',
};

export const TEMPLATE_IMPORT_METHODS_LIST = [TEMPLATE_IMPORT_METHODS.SPM_FILE, TEMPLATE_IMPORT_METHODS.THIRD_PARTY];
